import i18n from '@/locales/index.js';
/**
 * 接口拦截器
 */
import axios from 'axios';
import Vue from "vue";
import store from "@/store"; 

// ? axios请求拦截器
axios.interceptors.request.use(
  (config) => {
    const token = Vue.prototype.$cookie.get('token');
    if (token && config.url.indexOf('sendMsgCaptcha')==-1) {
      if (!config.headers.Authorization) {
        config.headers.Authorization = token;
      }
    }
    config.headers['Zd-Platform-Type'] = 'Zd-Portal';
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

// ? axios响应拦截器
let isOvertime = true;
axios.interceptors.response.use(
  (response) => {
    //快过期时更新token
    const newToken = response.headers['fresh-jwt'];
    if (newToken) {
      Vue.prototype.$local.set('token', newToken);
      Vue.prototype.$cookie.set('token', newToken)
      window.sessionStorage.setItem('token', newToken);
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      let data = { message: i18n.t('api.httpinterceptor.q6n8xn'), msg: i18n.t('api.httpinterceptor.q6n8xn') };
      return Promise.reject(data);
    }
    intercept(error.response);
    let data = error.response ? error.response.data : error;
    return Promise.reject(data);
  },
);

const intercept = (response) => {
  if (response && (response.status === 412 || response.status === 417 || response.status == 401) && isOvertime) {
    if (isOvertime) 
    store.commit('UPDATEOVERTIMESTATUS', true);
    isOvertime = false;
    if (!window.location.href.includes('/login')) {
      Vue.prototype.$local.clear('token');
      Vue.prototype.$cookie.set('token', '')
      Vue.prototype.$cookie.set('userId','')
      window.sessionStorage.clear();
      isOvertime = true;
      if (window.__POWERED_BY_WUJIE__) {
        window.$wujie?.props.jump({actionType: "timeOver"});
      }
    }
  }
};

